import React from 'react';
import { graphql, useFragment } from 'react-relay';
import {
	DONE,
	IN_PROGRESS,
	statusCategoryForId,
	TODO,
	UNDEFINED,
} from '@jira/platform__status-categories/src/status-categories.tsx';
import Lozenge from '@atlaskit/lozenge';
import type { StatusGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/StatusGroupHeader.graphql';

export type Props = {
	statusGroupHeader: StatusGroupHeader$key | null;
};

const appearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

export const StatusGroupHeader = ({ statusGroupHeader }: Props) => {
	const data = useFragment<StatusGroupHeader$key>(
		graphql`
			fragment StatusGroupHeader on JiraJqlStatusFieldValue {
				displayName
				statusCategory {
					statusCategoryId
				}
			}
		`,
		statusGroupHeader,
	);

	const appearance =
		data?.statusCategory.statusCategoryId != null
			? appearanceMap[statusCategoryForId(data?.statusCategory.statusCategoryId)]
			: appearanceMap[UNDEFINED];

	return <Lozenge appearance={appearance}>{data?.displayName}</Lozenge>;
};
